export default "__VITE_ASSET__CZZxmrOz__"